'use strict'

const messages = {
    ru: {
        common: {
            back: 'Назад',
            empty: 'Данные отсутствуют',
            copyright: 'Разработка – Soft-logic',
            close: 'Закрыть'
        },
        home: {
            title: 'Выберите фильм'
        },
        init: {
            title: 'Загрузка...'
        },
        phone: {
            title: 'Номер телефона'
        },
        client: {
            title: 'Клиент',
            number: 'Ваш номер',
            before: {
                title: 'Перед вами',
                suffix: 'человек(а)'
            }
        },
        servicing: {
            title: 'Обслуживание',
            desc: 'Пройдите к месту'
        },
        success: {
            title: 'Будем рады видеть Вас снова!'
        },
        confirm: {
            title: 'Введите ваши <br> контактные данные',
            next: 'Продолжить'
        },
        error: {
            title: 'Ошибка',
            desc: 'Попробуйте позже или обратитесь к администратору',
            apiKeyNotFound: 'Ключ не найден. Обратитесь к администратору.',
            referrer: 'Недоступно для вашего сайта'
        },
        warning: {
            title: 'Предупреждение',
            desc: 'Время занято, выберете другое'
        },
        preRegistration: {
            name: 'Ваше имя',
            phone: 'Телефон',
            email: 'E-mail',
            location: 'Адрес филиала',
            queueName: 'Услуга',
            date: 'Дата',
            time: 'Время',
            noTimeToPreRegistration: 'К сожалению, на выбранную дату нет записи. Попробуйте выбрать другой день',
            allTimeBusyToPreRegistration: 'К сожалению, на этот период нет свободных слотов для записи. Попробуйте выбрать другой день',
            registration: 'Записаться',
            captcha: 'Символы с картинки',
            confirmEmailCode: 'Введите код (email)',
            confirmPhoneCode: 'Введите код (SMS)',
            confirmEmail: 'Отправить код по email',
            confirmPhone: 'Отправить код по SMS',
            forConfirm: 'для отправки кода',
            scheduleNotHasPlace: 'Выберите другое время',
            next: 'Далее',
            prev: 'Назад',
            cancel: 'Отмена',
            registratorNotFound: 'Нет регистраторов доступных для записи <br/>Обратитесь в поддержку',
            resendCode: 'Повторно запросить код можно через',
            resendSms: 'Если СМС не пришло, запросите код повторно',
            resendEmail: 'Если e-mail не пришел, запросите код повторно',
            comment: 'Комментарий',
            personalDataAgreement: 'Согласие на обработку персональных данных'
        },
        successRegistration: {
            success: 'Ждем Вас {date} в {time} по адресу: {address}.',
            visit: {
                title: 'При посещении:',
                item1: 'В терминале электронной очереди выберите раздел «я уже записан»',
                item2: 'Введите код из смс',
                item3: 'Возьмите талончик',
                item4: 'Дождитесь голосового приглашения к специалисту'
            },
            back: 'Вернуться к выбору услуг'
        },
        validation: {
            required: 'Обязательное поле',
            maxLength: 'Максимальная длина {value} символов',
            invalid: 'Некорректное значение',
            requiredTimes: 'Выберите время',
            requiredName: 'Введите имя',
            requiredPhone: 'Введите телефон',
            requiredEmail: 'Введите e-mail',
            requiredPersonalDataAgreement: 'Подтвердите согласие на обработку персональных данных'
        },
        calendar: {
            weekHeader: 'Неделя',
            today: 'Текущее время',
            clear: 'Очистить',
            dayNames: {
                sunday: 'Воскресенье',
                monday: 'Понедельник',
                tuesday: 'Вторник',
                wednesday: 'Среда',
                thursday: 'Четверг',
                friday: 'Пятница',
                saturday: 'Суббота'
            },
            dayNamesShort: {
                sunday: 'Вc',
                monday: 'Пн',
                tuesday: 'Вт',
                wednesday: 'Ср',
                thursday: 'Чт',
                friday: 'Пт',
                saturday: 'Сб'
            },
            monthNames: {
                january: 'Январь',
                february: 'Февраль',
                march: 'Март',
                april: 'Апрель',
                may: 'Май',
                june: 'Июнь',
                july: 'Июль',
                august: 'Август',
                september: 'Сентябрь',
                october: 'Октябрь',
                november: 'Ноябрь',
                december: 'Декабрь'
            }
        }
    }
}

export default messages
